/**
 * The "Show all (N)" ghost button rendered by the bottom cap-footer
 * (`IndexGridCapFooter`). `total` is the post-column-filter row count;
 * `onClick` lifts the render cap (typically `shell.setShowAll(true)`).
 */
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';

export interface IndexGridShowAllButtonProps {
  total: number;
  onClick: () => void;
}

export function IndexGridShowAllButton({ total, onClick }: IndexGridShowAllButtonProps) {
  const { t } = useTranslation('spreadsheet');
  return (
    <Button type="button" variant="ghost" size="sm" onClick={onClick}>
      {t('indexGrid.showAll', { total })}
    </Button>
  );
}
